var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-y-auto overflow-x-hidden"},[_c('feedback-form',{attrs:{"title-border-radius":"0"},on:{"close":_vm.onClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }